/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import { React, PT, fetchApi, connect } from '@gasbuddy/react';
import { Modal, Header, Button, Icon, Message, List } from 'semantic-ui-react';

class BaseAwardModal extends React.Component {
  state = {}

  callApi = () => {
    const { accountId, transactionId, fetch } = this.props;
    this.setState({ saving: true }, async () => {
      const { body, status, error } = await fetchApi({
        url: `/payments/transaction/${accountId}/${transactionId}/settle-gasback`,
        catchErrors: true,
        body: { },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error, saving: false });
      } else {
        this.setState({ opened: false, error: null, saving: false }, fetch);
      }
    });
  }

  render() {
    const { opened, error, saving } = this.state;
    return (
      <Modal
        open={opened}
        trigger={<Button onClick={() => this.setState({ opened: true })}>Award Pending Gasback</Button>}
      >
        <Header icon="attention" content="Award Pending Gasback" />
        <Modal.Content>
          {error
            && (
            <Message negative>
              <Message.Content>
                <List>
                  <List.Header>Cannot settle Gasback:</List.Header>
                  {(error.log || []).map(l => (
                    <List.Item>
                      {l.message}
                    </List.Item>
                  ))}
                </List>
              </Message.Content>
            </Message>
            )
          }
          {!error && (
            <Message>
              This will override the lockin period for the
              transaction and make the funds available for usage
              for fuel purchases. In other words, there&apos;s no going back
              after doing this.
            </Message>
          )
          }
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
            Cancel
          </Button>
          <Button loading={saving} basic color="blue" onClick={this.callApi}>
            <Icon name="dollar" />
            {' '}
            Confirm
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

BaseAwardModal.propTypes = {
  accountId: PT.number,
  transactionId: PT.number,
  fetch: PT.func.isRequired,
};

BaseAwardModal.defaultProps = {
  transactionId: 0,
  accountId: 0,
};

export const AwardGasbackModal = connect(() => {})(BaseAwardModal);
